interface IVariableFont {
  readonly light: string;
  readonly medium: string;
  readonly default: string;
  readonly raw: string;
}

interface IFontFamilies {
  readonly sans: IVariableFont;
}

interface IBase {
  font: string;
  fontSize: string;
  lineHeight: string;
  letterSpacing: string;
}

interface ITypography {
  base: IBase;
  fontFamilies: IFontFamilies;
}

const fontFamilies: IFontFamilies = {
  sans: {
    light: `font-family: GOATProductVariableVF, sans-serif; font-weight: 300;`,
    medium: `font-family: GOATProductVariableVF, sans-serif; font-weight: 700;`,
    default: `font-family: GOATProductVariableVF, sans-serif; font-weight: 400;`,
    raw: `font-family: GOATProductVariableVF, sans-serif;`, // no hard coded weight, free use
  },
};

const base: IBase = {
  font: fontFamilies.sans.default,
  fontSize: '12px',
  lineHeight: '1.5',
  letterSpacing: '0px',
};

export const typography: ITypography = {
  base,
  fontFamilies,
};
